import { Module } from './base';
import { getTranslation } from "../components/i18n";
import SettingsPersistor from "../components/settings-persistor";

class SimpleLangToggleModule implements Module {
  name = 'simple-lang-toggle';

  setup(a11ySettings: Record<string, any>, modulesContainer: HTMLElement) {
    const moduleName = this.name;
    const toggleData = (toggle: boolean) => {
      const simpleElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-has-simple-lang="true"]');
      simpleElements.forEach((simpleElement) => {
        let content = simpleElement.dataset.contentRegular ? simpleElement.dataset.contentRegular : '';
        if (toggle && simpleElement.dataset.contentSimple) {
          content = simpleElement.dataset.contentSimple
        }
        if (simpleElement.dataset.simpleContentHasHtml) {
          simpleElement.innerHTML = content;
        } else {
          simpleElement.textContent = content;
        }
      });
    };
    const observer = new MutationObserver((mutations) => { 
      const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
      if (hasNewNodes) {
        observer!.disconnect();
        try {
          toggleData(true);
        } finally {
          observer!.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      }
    });
    const simpleLangElement = document.createElement("div");
    simpleLangElement.className = `a11y-module a11y-module-${moduleName}`;
    simpleLangElement.innerHTML = `
      <label id="a11y-${moduleName}-label" for="toggle-${moduleName}" data-translation-field="true" data-translation-key="simpleLang">${getTranslation('simpleLang')}</label>
      <label class="a11y-toggle" tabindex="0" aria-labelledby="a11y-${moduleName}-label a11y-${moduleName}-label-text">
        <span id="a11y-${moduleName}-label-text" class="screen-reader-text">Die Option ist <span class="toggle-state-text"></span></span>
        <input id="toggle-${moduleName}" type="checkbox" tabindex="-1">
        <span class="slider"></span>
      </label>
    `;
    modulesContainer.appendChild(simpleLangElement);
    const simpleLangToggle = document.getElementById(`toggle-${moduleName}`) as HTMLInputElement;
    const toggleStateText = simpleLangElement.querySelector(`.toggle-state-text`) as HTMLSpanElement;
    simpleLangToggle.addEventListener("click", () => {
      toggleStateText.innerText = simpleLangToggle.checked ? 'aktiviert' : 'deaktiviert';
      document.body.dataset.simpleLanguage = String(simpleLangToggle.checked);
      if (simpleLangToggle.checked) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else {
        observer.disconnect();
      }
      toggleData(simpleLangToggle.checked);
      SettingsPersistor.save(moduleName, simpleLangToggle.checked);
    });
    toggleStateText.innerText = a11ySettings[moduleName] ? 'aktiviert' : 'deaktiviert';
    if (a11ySettings[moduleName]) {
      simpleLangToggle.checked = a11ySettings[moduleName];
      if (simpleLangToggle.checked) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
        toggleData(simpleLangToggle.checked);
      }
      document.body.dataset.simpleLanguage = String(simpleLangToggle.checked);
    }
    return '';
  }

  reset() {
    const toggle = document.getElementById('toggle-simple-lang-toggle') as HTMLInputElement;
    if (toggle) {
      toggle.checked = false;
      toggle.dispatchEvent(new Event('click'));
    }
    document.body.dataset.simpleLanguage = 'false';
  }
}

export default new SimpleLangToggleModule();